import { getApiBaseUrl } from '../../../utils/apiConfig';

const URL = () => `${getApiBaseUrl()}/api/pg-native/config/anchor-technician`;
const auth = () => ({ Authorization: `Bearer ${localStorage.getItem('authToken') || ''}` });

/** { nativeOperation, data: { code, name, active } | null } */
export async function fetchAnchorTechnician() {
  const res = await fetch(URL(), { headers: auth() });
  const j = await res.json().catch(() => ({}));
  if (!res.ok || !j.success) throw new Error(j.message || 'Erro ao carregar o técnico âncora');
  return { nativeOperation: !!j.nativeOperation, data: j.data || null };
}

/** Código vazio remove a configuração. */
export async function saveAnchorTechnician(code) {
  const res = await fetch(URL(), {
    method: 'PUT',
    headers: { ...auth(), 'Content-Type': 'application/json' },
    body: JSON.stringify({ code }),
  });
  const j = await res.json().catch(() => ({}));
  if (!res.ok || !j.success) throw new Error(j.message || 'Erro ao salvar o técnico âncora');
  return j.data || null;
}
